import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-pen-tool-vector-icon',
  templateUrl: './design-pen-tool-vector.component.html'
})
export class DesignPenToolVectorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
